"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagXK = function FlagXK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.85-30.63c-4.08-.78-9-6-7.28-8.83S12-48.73,8.05-46.52,1.43-41.67-2.32-40.79s-6.85,3.75-4,6.4,7.28,8,3.09,13.47-2.87,1.76-7.94,4.19-8.61,7.28-7.07,10.15,2.87,4-1.54,6S-26.16,0-29.69.93s-12.14,5.29-14.79,9-8.38.23-10.81-.22-7.28,1.32-8.39,4.2.88,5.51,5.08,6.84,6,1.54,4,5.07S-55.29,36.23-52,38.22s9.71,8.17,9.71,12.36S-43.15,61-37,61.84s15.66,3.53,19,9.26a35.3,35.3,0,0,1,4.86,12.58A35,35,0,0,0-9.83,94.05c2,4,3.31,10.82,1.33,12.36s-3.54,2.65-2,5.63,1.88,4.08,4.74,2.43,2.87.11,4.42-.22S7.27,111.38,6,108,1.76,96.7,5.84,92.62s9.6-4.74,13.13-7.5,9.38-3.2,13.91-7.62S42.25,75.74,43,78.83s2,9,5.51,8.94,4.31-.11,5-4.42,6.18-13.9,8.38-12.69,4.2.22,4.31-1.65,4.3-3.53,6.07-.89,5.62,4.75,5.51,1.44S73.15,66.69,73,63.05s3.64-6,6.95-7.51,1.33-5.51,2.32-7.72,6.4-5,6.62-7.17-1.32-3.09,1-3.64,5.19-1.55,3.53-4.08-1.1-4.42.67-5.63,2.59-7,0-7.73S86.91,21,85.74,22.4s-5.9-4.65-8.14-6.15-16.7-.58-16.37-3.07S67.63,1.59,65,.15A68.55,68.55,0,0,0,54.72-4.48c-3.42-1.11-2.65,2.64-4.52-.33s-2.54-13.58-4.63-13.58S41.93-14,41-15.63,41.37-28.76,36.52-29s-5,2.65-7.73.55-2.36-1.15-7.94-2.2Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#ff9b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.13-93.41l-3.67,11-11.58.09a.67.67,0,0,0-.39,1.2l9.32,6.88-3.5,11a.66.66,0,0,0,1,.73L-8.5-69.2.92-62.47a.66.66,0,0,0,1-.73l-3.5-11,9.33-6.88a.67.67,0,0,0-.39-1.2l-11.59-.09-3.67-11a.66.66,0,0,0-1.25,0Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.7-93.41,28-82.42l-11.58.09a.67.67,0,0,0-.39,1.2l9.32,6.88-3.5,11a.66.66,0,0,0,1,.73l9.42-6.73,9.43,6.73a.66.66,0,0,0,1-.73l-3.5-11,9.32-6.88a.67.67,0,0,0-.38-1.2l-11.59-.09L33-93.41a.66.66,0,0,0-1.25,0Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-49.41-86.68l-3.66,11-11.59.09A.67.67,0,0,0-65-74.4l9.32,6.88-3.49,11a.66.66,0,0,0,1,.73l9.43-6.73,9.43,6.73a.66.66,0,0,0,1-.73l-3.49-11,9.32-6.88a.67.67,0,0,0-.39-1.2l-11.58-.09-3.67-11a.67.67,0,0,0-1.26,0Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-87.51-72.83l-3.67,11-11.59.09a.66.66,0,0,0-.38,1.19l9.32,6.89-3.5,11.05a.66.66,0,0,0,1,.73l9.42-6.73,9.43,6.73a.66.66,0,0,0,1-.73l-3.5-11.05,9.32-6.89A.66.66,0,0,0-71-61.75l-11.59-.09-3.67-11a.66.66,0,0,0-1.25,0Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.12-86.68l3.66,11,11.59.09a.67.67,0,0,1,.39,1.2l-9.32,6.88,3.49,11a.66.66,0,0,1-1,.73l-9.43-6.73-9.43,6.73a.66.66,0,0,1-1-.73l3.49-11L56.22-74.4a.67.67,0,0,1,.39-1.2l11.59-.09,3.66-11a.67.67,0,0,1,1.26,0Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M111.22-72.83l3.67,11,11.59.09a.66.66,0,0,1,.38,1.19l-9.32,6.89L121-42.62a.66.66,0,0,1-1,.73l-9.42-6.73-9.43,6.73a.66.66,0,0,1-1-.73l3.49-11.05-9.32-6.89a.66.66,0,0,1,.38-1.19l11.59-.09,3.67-11a.66.66,0,0,1,1.25,0Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagXK;
exports["default"] = _default;